import script from "./scanning-config.vue?vue&type=script&setup=true&lang=ts"
export * from "./scanning-config.vue?vue&type=script&setup=true&lang=ts"

import "./scanning-config.vue?vue&type=style&index=0&id=8aba281c&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8aba281c"]])

export default __exports__